import { SEOHead } from "@/components/SEOHead";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useLanguage } from "@/contexts/LanguageContext";

const DriversLibrary = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-slate-50 font-sans">
      <SEOHead 
        title={language === 'ru' ? 'БИБЛИОТЕКА ВОДИТЕЛЯ' : "DRIVER'S LIBRARY"}
        description={language === 'ru' 
          ? 'Важные и полезные инструкции для ваших повседневных задач' 
          : 'IMPORTANT AND USEFUL TUTORIALS THAT HELP YOU WITH YOUR DAY-TO-DAY TASKS'}
        canonical="/driverslibrary"
      />
      <Navbar />
      
      <main className="pb-20 lg:pb-32">
        {/* Header Section */}
        <section className="container mx-auto px-4 pt-28 lg:pt-36 mb-12 text-center">
          <div className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary font-semibold text-sm mb-6 border border-primary/20 tracking-wide uppercase">
            {language === 'ru' ? 'Обучение' : 'Tutorials'}
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold text-navy-950 mb-6 tracking-tight">
            {language === 'ru' ? 'БИБЛИОТЕКА ВОДИТЕЛЯ' : "DRIVER'S LIBRARY"}
          </h1>
          <p className="text-sm md:text-base text-slate-500 max-w-2xl mx-auto uppercase tracking-wider font-medium">
            {language === 'ru' 
              ? 'Важные и полезные инструкции для ваших повседневных задач' 
              : 'IMPORTANT AND USEFUL TUTORIALS THAT HELP YOU WITH YOUR DAY-TO-DAY TASKS'}
          </p>
        </section>

        {/* Video Section */}
        <section className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-xl shadow-primary/5 border border-slate-100">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-navy-950 mb-3">
                {language === 'ru' 
                  ? 'Как зарегистрироваться как водитель в Clearinghouse' 
                  : 'How to register as a driver in Clearinghouse'}
              </h2>
            </div>
            
            <div className="flex justify-center">
              {/* Phone Mockup Container */}
              <div className="relative w-full max-w-[360px] rounded-[2.5rem] overflow-hidden shadow-2xl shadow-navy-950/20 border-[10px] border-navy-950 bg-navy-950 aspect-[9/16] group">
                <div className="absolute top-0 inset-x-0 h-6 bg-navy-950 z-20 rounded-b-2xl w-1/2 mx-auto"></div>
                <video 
                  controls 
                  playsInline 
                  className="w-full h-full object-cover rounded-[1.8rem] bg-black"
                >
                  <source src="https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/6a0e5d871e90e4b6068eb3f5.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default DriversLibrary;
